import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AppConfigService } from 'src/app/app-config.service';
import { EndpointBuilderService } from 'src/app/shared/services/endpint-builder.service';
import { ApiEnum } from 'src/app/shared/enum/api.enum';
import { CommonService } from '../../common-service';
import { ReturnStruct } from 'src/app/shared/structs/return.struct';

@Injectable({
  providedIn: 'root'
})
export class GroupOriginOrchestratorUserService extends CommonService {

  constructor(private httpClient: HttpClient, configService:AppConfigService, private endpointBuilder: EndpointBuilderService) { super(configService); }

  public deleteGroupOrigin(idGroupOrigin: number): Observable<ReturnStruct> {
    let uri = `GroupOrigin/idGroupOrigin/${idGroupOrigin}`

    return this.httpClient.delete<ReturnStruct>(this.endpointBuilder.getEndpoint(ApiEnum.urlApiOrchestratorUser) + uri, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }
}